import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// 导入Element Plus基础样式
import 'element-plus/dist/index.css'
// 自定义样式放在Element Plus之后导入，确保优先级
import './style.css'
// 导入Vue i18n
import { createI18n } from 'vue-i18n'
// 导入语言包
import zh from './locales/zh'
import en from './locales/en'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 创建全局ref存储isAdmin变量
// 健壮的布尔值转换逻辑，确保正确处理各种形式的值
const isAdminValue = import.meta.env.VITE_isAdmin;
// 只有当值是'true'（不区分大小写）或布尔值true时才为true，其他情况（包括'false'、'False'、null、undefined等）都为false
const isAdmin = (typeof isAdminValue === 'string' && isAdminValue.toLowerCase() === 'true') || 
  isAdminValue === true

// 创建i18n实例
const i18n = createI18n({
  legacy: true, // 使用组合式API
  locale: 'zh', // 默认语言
  messages: {
    zh,
    en
  }
})

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(router)
// 使用i18n
app.use(i18n)
console.log('isAdmin:', isAdmin)
// 将isAdmin添加到全局属性中，方便所有组件访问
app.config.globalProperties.$isAdmin = isAdmin

app.mount('#app')
